// IE9,10,11
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import { StrictMode } from "react";
import ReactDOM from "react-dom";

import App from "./App";

const rootElement = document.getElementById("root");
ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  rootElement
);
